import { ModuleDto } from "@constants/modules";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../axios-instance";

const fetchSiteModules = async (site: string): Promise<ModuleDto[]> => {
  const url = `/sites/${site}/modules`;
  return (await axiosInstance.get<ModuleDto[]>(url)).data;
};

export const prefetchSiteModules = async (
  queryClient: QueryClient,
  site: string
) => {
  await queryClient.prefetchQuery({
    queryKey: [site, "modules"],
    queryFn: () => fetchSiteModules(site),
    staleTime: 30_000,
  });
};

export function useSiteModulesApi(site?: string) {
  return useQuery({
    queryKey: [site, "modules"],
    queryFn: () => fetchSiteModules(site!),
    enabled: !!site,
    staleTime: 30_000,
  });
}
